import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  getAllTeleconsultations,
  updateTeleconsultation,
} from 'api/teleconsultations';
import { getAllDoctors } from 'api/doctors';
import { updateCustomer } from 'api/customers';
import { filtersToQueryString, initialFilters } from 'helpers/filtering';
import { setDoctorOptions } from 'helpers/doctor';
import { runUpdater } from 'updaters/teleconsultation';
import { SECOND_TELE_COLUMNS } from 'config/teleconsultation';
import MainViewWithTable from 'components/main_view_with_table';
import TeleconsultationButtons from 'components/teleconsultation_buttons';

const SecondTeleconsultations = ({ onCountUpdate, onMessages }) => {
  const [meta, setMeta] = useState({});
  const [fetching, setFetching] = useState(true);
  const [allTeles, setAllTeles] = useState([]);
  const [columns, setColumns] = useState(SECOND_TELE_COLUMNS);

  const fetchData = async (page, filters = {}, search) => {
    filters['stage'] = ['second'];
    const filtersString = filtersToQueryString(filters, search);
    const data = await getAllTeleconsultations(page, filtersString);

    setAllTeles([...data.items]);
    setMeta(data.meta);
    setFetching(false);
  };

  useEffect(() => {
    (async () => {
      const allDoctors = await getAllDoctors();
      const newColumns = setDoctorOptions({
        columns: SECOND_TELE_COLUMNS,
        data: allDoctors,
      });

      const initFilters = initialFilters(SECOND_TELE_COLUMNS);
      await fetchData(1, initFilters);

      setFetching(false);
      setColumns(newColumns);
    })();
  }, []);

  const handleSelect = async (prop, value, c) => {
    const index = allTeles.findIndex((t) => t.id === c.id);

    const newTeles = await runUpdater(allTeles, c, columns, prop, value, index);

    const {
      teleconsultation,
      meta: { messages },
    } = await updateTeleconsultation(c.id, {
      ...c,
      [prop]: value,
    });

    newTeles[index] = teleconsultation;

    setAllTeles([...newTeles]);
    onCountUpdate();
    onMessages(messages);
  };

  const handleTextUpdate = async (value, c) => {
    const index = allTeles.findIndex((t) => t.id === c.id);

    const updatedCustomer = await updateCustomer(c.customer.id, {
      notes: value,
    });

    allTeles[index].customer = updatedCustomer;

    setAllTeles([...allTeles]);
    onCountUpdate();
  };

  const props = {
    data: allTeles,
    columns,
    fetchData,
    fetching,
    meta,
    onSelect: handleSelect,
    onTextUpdate: handleTextUpdate,
    title: 'Second teleconsultations',
    accessor: 'teleconsultations',
  };

  return (
    <MainViewWithTable {...props}>
      <TeleconsultationButtons />
    </MainViewWithTable>
  );
};

SecondTeleconsultations.propTypes = {
  onCountUpdate: PropTypes.func.isRequired,
  onMessages: PropTypes.func.isRequired,
};

export default SecondTeleconsultations;
